module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productDustribut"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 客户列表")]), _vm._v(" "), _c('div', {
    staticClass: "minWidth"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称/vip号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称/vip号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWordB),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordB", $$v)
      },
      expression: "searchData.keyWordB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入昵称",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWordC),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordC", $$v)
      },
      expression: "searchData.keyWordC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.initData()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.routerTo
    }
  }, [_vm._v("充 值")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerList,
      "border": "",
      "default-sort": {
        prop: 'balance',
        order: 'descending'
      },
      "stripe": ""
    },
    on: {
      "sort-change": _vm.sortBalance
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "头像",
      "header-align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', [_c('el-image', {
          staticClass: "imgRaduis",
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.photo,
            "fit": "contain"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n              " + _vm._s(scope.row.nickname) + "\n            ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.realName) ? _c('div', [_vm._v(_vm._s(scope.row.realName))]) : _c('div', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "注册时间",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.addDate) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.mobile) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单配额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.demandCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "align": "center",
      "prop": "balance",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "消费金额",
      "align": "center",
      "prop": "amount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('p', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.deliveryAddress))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.remark) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editUser(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.delAppendUser(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "400px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "realName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.realName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "realName", $$v)
      },
      expression: "editDialog.data.realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "mobile",
      "label": "手机号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "demandCount",
      "label": "工单预期："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "工单预期",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.demandCount),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "demandCount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.demandCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "客户备注："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "客户备注",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryId",
      "label": "派送点："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editDialog.data.deliveryId),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "deliveryId", $$v)
      },
      expression: "editDialog.data.deliveryId"
    }
  }, _vm._l((_vm.deliveryList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.addressId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitUser()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "visible": _vm.deleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.deleteDialog, "show", $event)
      }
    }
  }, [_c('span', [_vm._v("您确定删除吗？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUser()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cea9f5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/personnel/customerList.vue
// module id = 1250
// module chunks = 2